<div class="photo-viewer-container fullscreen-modal">
  <div class="photo-viewer" (wheel)="onWheel($event)">
    <img *ngFor="let img of currentImage" [src]="img" [ngStyle]="{
      transform: 'scale(' + zoomLevel + ') translate(' + translateX + 'px, ' + translateY + 'px) rotate(' + rotation + 'deg)'
   }" (mousedown)="startDrag($event)" (mousemove)="onDrag($event)" (mouseup)="endDrag()" (mouseleave)="endDrag()"
      alt="Image viewer" />
  </div>

  <div class="controls" style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
    <button mat-icon-button (click)="zoomIn()"
      style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
      <mat-icon style="color: green;">zoom_in</mat-icon>&nbsp;
      <span>Zoom In</span>
    </button>

    <button mat-icon-button (click)="zoomOut()"
      style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
      <mat-icon style="color: red;">zoom_out</mat-icon>&nbsp;
      <span>Zoom Out</span>
    </button>

    <button mat-icon-button (click)="rotateClockwise()"
      style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
      <mat-icon style="color: blue;">rotate_right</mat-icon>&nbsp;
      <span>Rotate Clockwise</span>
    </button>

    <button mat-icon-button (click)="rotateCounterClockwise()"
      style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
      <mat-icon style="color: orange;">rotate_left</mat-icon>&nbsp;
      <span>Rotate Counterclockwise</span>
    </button>

    <button mat-icon-button (click)="resetZoom()"
      style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
      <mat-icon style="color: purple;">refresh</mat-icon>&nbsp;
      <span>Reset</span>
    </button>

    <button mat-icon-button (click)="closeDialog()"
      style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
      <mat-icon style="color: gray;">close</mat-icon>&nbsp;
      <span>Close</span>
    </button>
  </div>


</div>